<div *ngIf="(loader.isLoading$ | async)" class="spinner-overlay">
   <mat-spinner role="progressbar" attr.aria-label="{{ 'loader.aria.spinner' | translate }}"></mat-spinner>
</div>